(() => {
  const pushEvent = (event, details = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...details });
  };

  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('#CartDrawer-Checkout');
    if (checkoutButton) {
      pushEvent('cart_drawer_checkout_click');
      return;
    }

    const bundleInvitation = event.target.closest('[data-bundle-invitation]');
    if (bundleInvitation) {
      pushEvent('product_bundle_invitation_click', {
        product_handle: bundleInvitation.dataset.productHandle || ''
      });
      return;
    }

    const upsellButton = event.target.closest('.rider-offer .upsell__add-btn');
    if (upsellButton) {
      const offer = upsellButton.closest('[data-handle]');
      pushEvent('cart_upsell_add_click', {
        product_handle: offer?.dataset.handle || ''
      });
    }
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || entry.target.dataset.trackedImpression === 'true') return;
        entry.target.dataset.trackedImpression = 'true';
        pushEvent('cart_upsell_impression');
      });
    },
    { threshold: 0.5 }
  );

  const observeOffers = () => {
    document.querySelectorAll('.rider-offer').forEach((offer) => observer.observe(offer));
  };

  observeOffers();
  document.addEventListener('cartQuantityUpdated', observeOffers);
})();
